// extracted by mini-css-extract-plugin
module.exports = {"cards_list":"styles_cards_list__2tVGc","card":"styles_card__16HtB","card__img":"styles_card__img__WAajM","card__text":"styles_card__text__2zvHt"};